import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Link } from 'react-router-dom';
import { Autoplay } from 'swiper/modules';
import { useCollection, resolveAssetUrl, resolveCmsList } from '../../public-cms/hooks';
import { tourDetailPath } from '../../lib/tourUrls';

function TourOne({ data = {} }) {
  const swiperRef = useRef(null);
  const cms = useCollection('/public/tours', { featured: true, market: 'nepal' });
  const { loading, items: tours } = resolveCmsList(cms);
  if (loading || tours.length === 0) return null;

  const slide = (dir) => {
    const swiper = swiperRef.current?.swiper;
    if (!swiper) return;
    if (dir === 'prev') swiper.slidePrev();
    else swiper.slideNext();
  };

  return (
    <section className="tour-area position-relative overflow-hidden space" id="service-sec">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 offset-lg-3">
            <div className="title-area text-center">
              <span className="sub-title">{data.subTitle || 'Best Place For You'}</span>
              <h2 className="sec-title">{data.title || 'Popular Nepal Experiences'}</h2>
              {data.text && <p className="sec-text">{data.text}</p>}
            </div>
          </div>
        </div>
        <div className="slider-area tour-slider di-tour-slider-wrap">
          <button
            type="button"
            className="di-tour-slider-arrow di-tour-slider-arrow--prev"
            onClick={() => slide('prev')}
            aria-label="Previous tours"
          >
            <i className="fa-regular fa-arrow-left" aria-hidden="true" />
          </button>

          <Swiper
            ref={swiperRef}
            modules={[Autoplay]}
            autoplay={{ delay: 3200, disableOnInteraction: false, pauseOnMouseEnter: true }}
            loop={tours.length > 1}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 2 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 3 },
              1400: { slidesPerView: 4 },
            }}
            spaceBetween={24}
            grabCursor
            className="swiper th-slider has-shadow slider-drag-wrap di-tour-swiper"
          >
            {tours.map((tour) => {
              const to = tourDetailPath(tour);
              const catName = tour.category?.name;
              const catSlug = tour.category?.slug;
              return (
                <SwiperSlide key={tour.slug || tour.id}>
                  <div className="tour-box th-ani gsap-cursor di-card-grid">
                    <div className="tour-box_img global-img">
                      <img src={resolveAssetUrl(tour.cardImageUrl || tour.featuredImageUrl) || '/assets/img/tour/tour_box_1.jpg'} alt={tour.title} width="424" height="250" loading="lazy" decoding="async" />
                      {catName && (
                        <Link
                          to={catSlug ? `/tour?category=${catSlug}` : '/tour'}
                          className="di-tour-tag"
                        >
                          {catName}
                        </Link>
                      )}
                    </div>
                    <div className="tour-content">
                      <h3 className="box-title">
                        <Link to={to}>{tour.title}</Link>
                      </h3>
                      <div className="tour-rating">
                        <div className="star-rating" role="img" aria-label="Rated 4.8 out of 5">
                          <span style={{ width: '96%' }}>Rated <strong className="rating">4.8</strong> out of 5</span>
                        </div>
                      </div>
                      {(tour.difficulty || tour.groupSizeMax) && (
                        <div className="di-card-meta">
                          {tour.difficulty && (
                            <span><i className="fa-light fa-gauge-simple-high" /> {tour.difficulty}</span>
                          )}
                          {tour.groupSizeMax && (
                            <span><i className="fa-light fa-user-group" /> Up to {tour.groupSizeMax}</span>
                          )}
                        </div>
                      )}
                      <h4 className="tour-box_price">
                        <span className="currency">{tour.basePrice ? `$${tour.basePrice}` : 'On request'}</span>
                        {tour.basePrice ? <span style={{ fontWeight: 400, fontSize: '0.85em' }}>/Person</span> : ''}
                      </h4>
                      <div className="tour-action">
                        <span>
                          <i className="fa-light fa-clock" />
                          {tour.durationDays ? ` ${tour.durationDays} Days` : ' Flexible'}
                        </span>
                        <Link to={to} className="th-btn style4 th-icon">View Details</Link>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>

          <button
            type="button"
            className="di-tour-slider-arrow di-tour-slider-arrow--next"
            onClick={() => slide('next')}
            aria-label="Next tours"
          >
            <i className="fa-regular fa-arrow-right" aria-hidden="true" />
          </button>
        </div>
      </div>
    </section>
  );
}

export default TourOne;
